import { render, staticRenderFns } from "./pause-button.vue?vue&type=template&id=dc7666da"
import script from "./pause-button.vue?vue&type=script&lang=ts"
export * from "./pause-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports